import { render } from "./ProjectContent.vue?vue&type=template&id=62437bbe"
import script from "./ProjectContent.vue?vue&type=script&lang=js"
export * from "./ProjectContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__